import React, { useEffect, useMemo, useRef, useState } from "react";

const STRATEGIC_PARTNERS = [
  {
    name: "Banred",
    short: "BANRED",
    accent: "#00e5ff",
    logo: "/assets/partners/strategic/banred.png",
    url: "https://www.banred.fin.ec",
  },
  {
    name: "Mastercard",
    short: "MASTERCARD",
    accent: "#ff5f00",
    logo: "/assets/partners/strategic/mastercard.png",
    url: "https://www.mastercard.com/lac/es.html",
  },
  {
    name: "Thales",
    short: "THALES",
    accent: "#8b5cff",
    logo: "/assets/partners/strategic/thales.png",
    url: "https://cpl.thalesgroup.com/es",
  },
];

const ECUADOR_CLIENTS = [
  { name: "BanEcuador", short: "BANECUADOR", logo: "/assets/clients/ecuador/banecuador.png", url: "https://www.banecuador.fin.ec" },
  { name: "Banco Atlántida", short: "ATLANTIDA", logo: "/assets/clients/ecuador/banco-atlantida.png", url: "https://www.bancoatlantida.ec" },
  { name: "DelBank", short: "DELBANK", logo: "/assets/clients/ecuador/delbank.png", url: "https://www.delbank.fin.ec" },
  { name: "CPN", short: "CPN", logo: "/assets/clients/ecuador/cpn.png", url: "https://www.cpn.fin.ec" },
  { name: "Chibuleo", short: "CHIBULEO", logo: "/assets/clients/ecuador/chibuleo.png", url: "https://www.chibuleo.com" },
  { name: "Tena", short: "TENA", logo: "/assets/clients/ecuador/tena.png", url: "https://cooptena.fin.ec" },
  { name: "Pablo Muñoz Vega", short: "PMV", logo: "/assets/clients/ecuador/pablo-munoz-vega.png", url: "https://www.cpmv.fin.ec" },
  { name: "CACSPMEC", short: "CACSPMEC", logo: "/assets/clients/ecuador/cacspmec.png", url: "https://cacspmec.fin.ec/home/inicio" },
  { name: "San José", short: "SANJOSE", logo: "/assets/clients/ecuador/san-jose.png", url: "https://www.coopsanjose.fin.ec" },
  { name: "Fasayñan", short: "FASAYNAN", logo: "/assets/clients/ecuador/fasaynan.png", url: "https://www.coopfasaynan.fin.ec" },
];

const COLOMBIA_CLIENTS = [
  { name: "AVP", short: "AVP", logo: "/assets/clients/colombia/avp.png", url: "https://cooperativaavp.com" },
  { name: "BIVE", short: "BIVE", logo: "/assets/clients/colombia/bive.png", url: "https://bive.com.co" },
  { name: "COEMASED", short: "COEMASED", logo: "/assets/clients/colombia/coemased.png", url: "https://www.coemasedboyaca.com" },
  { name: "COMULSEB", short: "COMULSEB", logo: "/assets/clients/colombia/comulseb.png", url: "https://www.comulseb.coop" },
  { name: "COOPCORONA", short: "COOPCORONA", logo: "/assets/clients/colombia/coopcorona.png", url: "https://coopcorona.com" },
  { name: "COOPEDAC", short: "COOPEDAC", logo: "/assets/clients/colombia/coopedac.png", url: "https://coopedac.com" },
  { name: "COOPETRABAN", short: "COOPETRABAN", logo: "/assets/clients/colombia/coopetraban.png", url: "https://www.coopetraban.com.co" },
  { name: "COOPEXTRAISS", short: "COOPEXTRAISS", logo: "/assets/clients/colombia/coopextraiss.png", url: "https://coopextraiss.com.co" },
  { name: "COOPICREDITO", short: "COOPICREDITO", logo: "/assets/clients/colombia/coopicredito.png", url: "https://www.linkedin.com/company/coopicredito" },
  { name: "CORBANCA", short: "CORBANCA", logo: "/assets/clients/colombia/corbanca.png", url: "https://corbanca.com.co" },
  { name: "CORNOTARE", short: "CORNOTARE", logo: "/assets/clients/colombia/cornotare.png", url: "https://cornotare.com.co" },
  { name: "CORVINDE", short: "CORVINDE", logo: "/assets/clients/colombia/corvinde.png", url: "https://corvinde.com.co" },
  { name: "COTRAFA", short: "COTRAFA", logo: "/assets/clients/colombia/cotrafa.png", url: "https://www.cotrafa.com.co" },
  { name: "CREDICOOP", short: "CREDICOOP", logo: "/assets/clients/colombia/credicoop.png", url: "https://www.credi.coop" },
  { name: "FAVUIS", short: "FAVUIS", logo: "/assets/clients/colombia/favuis.png", url: "https://favuis.com/site/" },
  { name: "FEISA", short: "FEISA", logo: "/assets/clients/colombia/feisa.png", url: "https://feisa.com.co" },
  { name: "FEMPOPULAR", short: "FEMPOPULAR", logo: "/assets/clients/colombia/fempopular.png", url: "https://fempopular.co" },
  { name: "FESPBUN", short: "FESPBUN", logo: "/assets/clients/colombia/fespbun.png", url: "https://fespbun.com" },
  { name: "FONABBOTT", short: "FONABBOTT", logo: "/assets/clients/colombia/fonabbott.png", url: null },
  { name: "FONCEL", short: "FONCEL", logo: "/assets/clients/colombia/foncel.png", url: "https://foncel.co" },
  { name: "FONEH", short: "FONEH", logo: "/assets/clients/colombia/foneh.png", url: "https://www.foneh.com/es/" },
  { name: "FONJUDICATURA", short: "FONJUDICATURA", logo: "/assets/clients/colombia/fonjudicatura.png", url: "https://www.fonjudicatura.org" },
  { name: "FONPELDAR", short: "FONPELDAR", logo: "/assets/clients/colombia/fonpeldar.png", url: "https://www.fonpeldar.com" },
  { name: "GES", short: "GES", logo: "/assets/clients/colombia/ges.png", url: "https://ges.com.co" },
  { name: "SOMOS", short: "SOMOS", logo: "/assets/clients/colombia/somos.png", url: "https://www.somoscooperativa.com.co" },
  { name: "UNIMOS", short: "UNIMOS", logo: "/assets/clients/colombia/unimos.png", url: "https://unimoscoop.com" },
];

const CLIENT_REGIONS = {
  ecuador: {
    label: "Ecuador",
    accent: "#00e5ff",
    items: ECUADOR_CLIENTS,
    speed: 58,
  },
  colombia: {
    label: "Colombia",
    accent: "#8b5cff",
    items: COLOMBIA_CLIENTS,
    speed: 118,
  },
};

const accents = ["#00e5ff", "#8b5cff", "#31f7d1", "#4c8dff", "#d45cff"];

const LogoItem = ({ item, index, isClone = false }) => {
  const accent = item.accent || accents[index % accents.length];
  const content = (
    <>
      <span className="logo-carousel-item__glow" style={{ background: accent }} />
      <span className="logo-carousel-item__accent" style={{ background: accent }} />
      <img
        src={item.logo}
        alt={item.name}
        loading="lazy"
        decoding="async"
        className="logo-carousel-item__image"
      />
    </>
  );

  const commonProps = {
    className: "partner-rail-card logo-carousel-item group",
    style: { "--logo-accent": accent },
  };

  if (!item.url) {
    return (
      <article
        {...commonProps}
        aria-hidden={isClone || undefined}
        aria-label={isClone ? undefined : `${item.name}. Sitio web no disponible`}
        title={isClone ? undefined : "Sitio web no disponible"}
      >
        {content}
      </article>
    );
  }

  return (
    <a
      {...commonProps}
      aria-hidden={isClone || undefined}
      aria-label={isClone ? undefined : `Visitar el sitio de ${item.name}`}
      tabIndex={isClone ? -1 : undefined}
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {content}
    </a>
  );
};

const buildLoopGroup = (items) => {
  const minimumItemsPerGroup = 12;
  const repetitions = Math.max(1, Math.ceil(minimumItemsPerGroup / items.length));
  return Array.from({ length: repetitions }, () => items).flat();
};

const LogoRail = ({ items, speed, ariaLabel }) => {
  const railRef = useRef(null);
  const marqueeItems = useMemo(() => buildLoopGroup(items), [items]);

  useEffect(() => {
    const rail = railRef.current;
    if (!rail) return undefined;

    let inViewport = false;
    const updatePlayback = () => {
      rail.classList.toggle(
        "is-partners-visible",
        inViewport && !document.hidden
      );
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        inViewport = entry.isIntersecting;
        updatePlayback();
      },
      { rootMargin: "40px 0px", threshold: 0.04 }
    );

    observer.observe(rail);
    document.addEventListener("visibilitychange", updatePlayback);

    return () => {
      observer.disconnect();
      document.removeEventListener("visibilitychange", updatePlayback);
      rail.classList.remove("is-partners-visible");
    };
  }, []);

  return (
    <div ref={railRef} className="partners-marquee logo-rail logo-carousel-viewport" aria-label={ariaLabel}>
      <div className="logo-rail-fade logo-rail-fade--left" />
      <div className="logo-rail-fade logo-rail-fade--right" />
      <div
        className="partners-marquee-track logo-carousel-track"
        style={{ "--marquee-duration": `${speed}s` }}
      >
        {[0, 1].map((groupIndex) => (
          <div className="logo-carousel-group" key={groupIndex} aria-hidden={groupIndex === 1}>
            {marqueeItems.map((item, index) => (
              <LogoItem
                key={`${groupIndex}-${item.short}-${index}`}
                item={item}
                index={index}
                isClone={groupIndex === 1 || index >= items.length}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const SectionIntro = ({ eyebrow, title, description, accent = "cyan", action }) => (
  <div className="logo-carousel-heading container-px mx-auto max-w-7xl">
    <div>
      <div className="logo-carousel-eyebrow">
        <span />
        <span className={accent === "violet" ? "text-violet" : "text-cyan"}>{eyebrow}</span>
      </div>
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
    </div>
    {action}
  </div>
);

const StrategicPartners = () => (
  <section
    className="strategic-partners-section logo-carousel-section logo-carousel-section--partners"
    data-testid="strategic-partners-section"
    aria-label="Socios estratégicos"
  >
    <div className="logo-carousel-grid" aria-hidden="true" />
    <SectionIntro
      eyebrow="Red de confianza"
      title="Socios estratégicos"
    />
    <LogoRail
      items={STRATEGIC_PARTNERS}
      speed={46}
      ariaLabel="Logos de socios estratégicos"
    />
  </section>
);

export const ClientsCarousel = () => {
  const [activeRegion, setActiveRegion] = useState("ecuador");
  const region = CLIENT_REGIONS[activeRegion];

  return (
    <section
      className="clients-section logo-carousel-section logo-carousel-section--clients"
      data-testid="clients-section"
      aria-label="Nuestros clientes"
    >
      <div className="logo-carousel-grid" aria-hidden="true" />
      <SectionIntro
        eyebrow="Presencia regional"
        title="Nuestros clientes"
        accent="violet"
        action={(
          <div
            className={`client-country-switch ${activeRegion === "colombia" ? "is-colombia" : "is-ecuador"}`}
            role="group"
            aria-label="Seleccionar país de clientes"
          >
            <span className="client-country-switch__thumb" aria-hidden="true" />
            {Object.entries(CLIENT_REGIONS).map(([key, item]) => (
              <button
                key={key}
                type="button"
                className={key === activeRegion ? "is-active" : ""}
                aria-pressed={key === activeRegion}
                onClick={() => setActiveRegion(key)}
              >
                <span className="client-country-switch__dot" style={{ background: item.accent }} />
                {item.label}
              </button>
            ))}
          </div>
        )}
      />

      <div className="client-logo-panel" role="region" aria-live="polite" aria-label={`Clientes de ${region.label}`}>
        <LogoRail
          key={activeRegion}
          items={region.items}
          speed={region.speed}
          ariaLabel={`Logos de clientes de ${region.label}`}
        />
      </div>
    </section>
  );
};

export default StrategicPartners;
